import { getHeaders } from "../utils";

export async function APICreateContract(orderId,tenderId,contractValue,contractedCompany, user, contractType = null, ) {
	try {
		const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

		const raw = {
			tenderId: tenderId,
			orderId: orderId,
			contractValue: contractValue,
			contractedCompany: contractedCompany,
			createdByUser: user?.id,
			createdByCompany: user?.companyId,
			contractType: (contractType !== null) ? contractType : null

		}

		const requestOptions = {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(raw),
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/contract/1.0/company/${user.companyId}/order/${orderId}`, requestOptions);
		const responseObject = await response.json();
		const createdContract = responseObject?.data;
		return createdContract;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APIGetContractPartner({orderId, companyId}) {
	try {
		const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

		const requestOptions = {
			method: 'GET',
			headers: headers,
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/contract/1.0/company/${companyId}/order/${orderId}/partner`, requestOptions);
		const responseObject = await response.json();
		const contractedPartner = responseObject?.data;
		return contractedPartner;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}